import { createAuthClient } from "better-auth/react"; // make sure to import from better-auth/react
import { organizationClient } from "better-auth/client/plugins";
import { AUTH_BASE_URL } from "@/env";

export const authClient = createAuthClient({
    baseURL: AUTH_BASE_URL, // Base URL of your Better Auth backend.
    plugins: [
        organizationClient(),
    ],
    sessionOptions: {
        refetchInterval: 60,
        refetchOnWindowFocus: true,
        refetchWhenOffline: false
    }
});
